import axios from "axios";
import parser from "xml-js";

const getMateriais = async () => {
  try {
    let pesquisa = JSON.parse(localStorage.getItem("pesquisa"));
    let query = `?codigogrupo=${pesquisa.CODIGO_GRUPO._text}&concorrente=${pesquisa.CONCORRENTE._text}&grupoconcorrente=${pesquisa.GRUPO_CONCORRENTE._text}&tipo=${pesquisa.TIPO._text}&werks=${pesquisa.WERKS._text}`;
    let response = await axios.get(
      window.url_api + "/app/zws_app_buscar_materiais" + query
    );
    response = parser.xml2json(response.data, { compact: true, spaces: 4 });
    response = JSON.parse(response);
    if (
      !response["soap-env:Envelope"]["soap-env:Body"][
        "n0:ZMM_WS_APP_BUSCAR_MATERIAISResponse"
      ]["T_DADOS_MATERIAIS"]["item"].length
    ) {
      return [
        response["soap-env:Envelope"]["soap-env:Body"][
          "n0:ZMM_WS_APP_BUSCAR_MATERIAISResponse"
        ]["T_DADOS_MATERIAIS"]["item"],
      ];
    }

    return response["soap-env:Envelope"]["soap-env:Body"][
      "n0:ZMM_WS_APP_BUSCAR_MATERIAISResponse"
    ]["T_DADOS_MATERIAIS"]["item"];
  } catch (error) {
    return [];
  }
};

export default {
  getMateriais,
};
